import React from 'react';
import Draggable from 'react-draggable';

const EditorCanvas = ({ elements, onElementChange, onSelectElement, selectedElementId, currentPageIdx, obraData }) => {
    // Detectar URL da API de forma mais robusta e dinâmica
    const getApiUrl = () => {
        // Se temos uma variável de ambiente, usamos o domínio correspondente para assets
        if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== '/api') {
            return process.env.REACT_APP_API_URL.replace('/api', '');
        }
        // Fallback: usar a origem atual (IP ou DDNS)
        return window.location.origin;
    };

    const apiUrl = getApiUrl();

    return (
        <div
            className="editor-canvas-container"
            style={{
                width: '842px',
                height: '595px',
                position: 'relative',
                backgroundColor: 'white',
                border: '1px solid #ccc',
                margin: '20px auto',
                overflow: 'hidden',
                boxShadow: '0 0 20px rgba(0,0,0,0.1)'
            }}
        >
            {/* Cabeçalho Automático: Capa (Grande) ou Páginas Inteiores (Condensado) */}
            {currentPageIdx === 0 ? (
                <div style={{
                    padding: '30px 40px',
                    borderBottom: '2px solid #2d3748',
                    marginBottom: '20px',
                    position: 'relative',
                    pointerEvents: 'none',
                    background: 'white',
                    zIndex: 1
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <img
                            src={`${apiUrl}/assets/logo-black.png`}
                            alt="SPROD Logo"
                            style={{ height: '50px', objectFit: 'contain' }}
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <h1 style={{
                            margin: 0,
                            fontSize: '24px',
                            color: '#2d3748',
                            fontWeight: '800',
                            letterSpacing: '2px',
                            textTransform: 'uppercase'
                        }}>
                            PLANO IMAGEM
                        </h1>
                        <div style={{ width: '150px' }}></div>
                    </div>

                    <div style={{ display: 'flex', gap: '30px', fontSize: '14px', color: '#4a5568' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Posição:</span>
                            <span>{obraData?.posicao || '---'}</span>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Local:</span>
                            <span>{obraData?.descricao || '---'}</span>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{
                    padding: '10px 20px',
                    borderBottom: '1px solid #cbd5e0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    pointerEvents: 'none',
                    background: 'white',
                    zIndex: 1,
                    height: '60px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <img
                            src={`${apiUrl}/assets/logo-black.png`}
                            alt="SPROD Logo"
                            style={{ height: '30px', objectFit: 'contain' }}
                            onError={(e) => e.target.style.display = 'none'}
                        />
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '700',
                            color: '#2d3748',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>PLANO IMAGEM</span>
                    </div>
                    <div style={{ display: 'flex', gap: '20px', fontSize: '12px', color: '#718096' }}>
                        <span><strong>Pos:</strong> {obraData?.posicao || '-'}</span>
                        <span><strong>Loc:</strong> {obraData?.descricao || '-'}</span>
                    </div>
                </div>
            )}
            {elements.map(el => (
                <Draggable
                    key={el.id}
                    position={{ x: el.x_position, y: el.y_position }}
                    onStop={(e, data) => onElementChange(el.id, { x_position: data.x, y_position: data.y })}
                    bounds="parent"
                >
                    <div
                        onClick={() => onSelectElement(el.id)}
                        style={{
                            position: 'absolute',
                            border: selectedElementId === el.id ? '2px solid #4299e1' : '1px dashed #cbd5e0',
                            cursor: 'move',
                            padding: el.type === 'asset' ? '0' : '8px',
                            backgroundColor: el.type === 'asset' ? 'transparent' : 'rgba(255,255,255,0.95)',
                            minWidth: el.width + 'px',
                            minHeight: el.height + 'px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: selectedElementId === el.id ? '0 0 0 2px rgba(66, 153, 225, 0.3)' : 'none',
                            ...el.styles
                        }}
                    >
                        {el.type === 'text' && <span>{el.content}</span>}
                        {el.type === 'variable' && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <span style={{ fontSize: '1.2em' }}>{el.icon || '🆔'}</span>
                                <span style={{ color: '#4299e1', fontWeight: 'bold', fontSize: '0.9em' }}>
                                    {`{${el.label}}`}
                                </span>
                            </div>
                        )}
                        {(el.type === 'asset' || el.type === 'image') && (
                            el.content && /\.(png|jpg|jpeg|webp|gif)$/i.test(el.content) ? (
                                <img
                                    src={`${apiUrl}/assets/maquetas/${el.content}`}
                                    alt={el.name || el.label}
                                    style={{
                                        width: el.width + 'px',
                                        height: el.height + 'px',
                                        objectFit: 'contain',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <div style={{
                                    width: el.width + 'px',
                                    height: el.height + 'px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: 'white',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '4px',
                                    fontSize: '2em',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                }}>
                                    <div>{el.icon || '📦'}</div>
                                    <div style={{ fontSize: '0.4em', color: '#718096', fontWeight: 'bold' }}>{el.name || el.label}</div>
                                </div>
                            )
                        )}

                    </div>
                </Draggable>
            ))}

            {/* Page Number (Bottom Right) - Only for non-cover pages */}
            {currentPageIdx > 0 && (
                <div style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '20px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#4a5568',
                    pointerEvents: 'none',
                    zIndex: 1
                }}>
                    {currentPageIdx}
                </div>
            )}
        </div>
    );
};

export default EditorCanvas;
